import React, { useEffect, useCallback } from 'react'
import { toast } from 'react-toastify'

const useFetch = ({ fn }) => {
  const [data, setData] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(null)
  const requestCounter = React.useRef(0)

  const fetchData = useCallback(
    async (...args) => {
      const currentRequestId = ++requestCounter.current
      try {
        setLoading(true)
        const response = await fn(...args)
        if (currentRequestId === requestCounter.current) {
          setData(response)
        }
      } catch (error) {
          if (currentRequestId === requestCounter.current) {
            setError(error)

            if (error?.response?.data?.message) {
              if (
                error?.response?.status === 401 ||
                error?.response?.status === 403
              ) {
                localStorage.removeItem('token')
                return (window.location.href = '/login')
              }
              toast.error(error.response.data.message)
            } else {
              toast.error(error.message)
            }
          }
        } finally {
        if (currentRequestId === requestCounter.current) {
          setLoading(false)
        }
      }
    },
    [fn],
  )
  useEffect(() => {
    fetchData()
  }, [])
  return { data, loading, error, setData, refetch: fetchData }
}

export default useFetch
